// extracted by mini-css-extract-plugin
export default {"modal":"wX-z","outfitSelector":"xX-z","outfitHeading":"yX-z","itemContainer":"zX-z","item":"AX-z","selected":"BX-z"};